// composables/useFetch.ts
import { useRequestTrackerStore } from '../stores/requestTracker';

export function useFetch(url: string | URL, options: RequestInit = {}) {
  const store = useRequestTrackerStore();

  const id = `${Date.now()}-${Math.random().toString(36).substring(2, 10)}`;
  const parsedUrl = typeof url === 'string' ? new URL(url) : url;
  const method = options.method?.toUpperCase() || 'GET';
  const body = options.body ? String(options.body) : undefined;
  const headers = options.headers ? JSON.stringify(options.headers) : undefined;

  store.addRequest({
    type: 'fetch',
    id,
    url: parsedUrl,
    method,
    body,
    headers,
    state: 'pending',
    progress: 0,
  });

  const updateProgress = (percent: number) => {
    store.updateRequest(id, { progress: percent });
  };

  const controller = store.getAbortController(id);

  const promise = (async () => {
    try {
      updateProgress(10);
      const response = await fetch(url, {
        ...options,
        signal: controller.signal,
      });
      updateProgress(60);
      const cloned = response.clone();
      await cloned.text(); // trigger download
      updateProgress(100);
      store.finishedRequest(id, response);
      return response;
    } catch (err: Error | any) {
      store.failedRequest(id, err);
      throw err;
    }
  })();

  const abort = () => store.abortRequest(id);

  return {
 requestId: id,
fetch: promise,
abort,
};
}
